module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"InputInfoToSearch":"Input info to search..."},"vi":{"InputInfoToSearch":"Nhập thông tin để tìm kiếm..."}}')
  delete Component.options._Ctor
}
